import Header from '../../../Shared-Component/Header/Header'
import Footer from '../../../Shared-Component/Footer/Footer'
import computer from "../../../assets/CampuLifeImages/canteen.JPG"
import CampusSlashTitle from '../../CampusSharedComponent/CampusTitles/CampusSlashTitle/CampusSlashTitle'
import CampusDynamicSection from '../../CampusSharedComponent/CampusSections/CampusDynamicSection/CampusDynamicSection'


const Canteen = () => {
     const libraryData = {
    img: computer,
    content: "Noorul Islam College of Arts & Science offers a clean, hygienic, and student-friendly canteen facility that caters to the nutritional needs of students, faculty, and staff. The canteen serves a variety of healthy and affordable meals, snacks, and beverages throughout the day, maintaining high standards of food quality and hygiene. With a spacious seating arrangement and a welcoming environment, it serves as a common space for relaxation and informal interaction. The menu is regularly updated to include both regional and popular cuisines. The canteen is managed by trained staff and operates during regular campus hours."
  }
 
  return (
    <>
     <div>
        <Header />
        <div className='campusmaincontainer'>
        <div className='campus-container'>
       <CampusSlashTitle slashTitle="Canteen" />
       <CampusDynamicSection data={libraryData} />
       </div>
      <Footer />
      </div>
      </div>
    </>
  )
}

export default Canteen